import CanvasCore from 'CanvasCore'
import { useUI } from 'Editor'
import React, { useEffect, useRef } from 'react'
import { useConfigStore } from 'AdminPanel/Spine/store/configStore'
import { useEditorStore as useSpineEditorStore } from 'AdminPanel/Spine/store/editorStore'
import { shouldUseAvatarSpinePreview } from 'Editor/lib/avatarSpinePreview'
import { getComponentCanvasSize } from 'Editor/utils/fullscreenType'
import AvatarEditorPreview from './AvatarEditorPreview'
import Overlay from './Overlay'

const CanvasPanel = ({ template }) => {
  const drawRef = useRef(null)
  const charDrawRef = useRef(null)
  const setCanvasDrawRef = useUI((s) => s.setCanvasDrawRef)
  const setCanvasCharDrawRef = useUI((s) => s.setCanvasCharDrawRef)

  const loadedRelatedTemplates = useConfigStore((s) => s.loadedRelatedTemplates)
  const selectedSkins = useSpineEditorStore((s) => s.selectedSkins)

  // 结合了关联 Spine 组件（已选中关联皮肤）→ 混合模式：统一 Spine 叠层预览 + 视频头像
  // 未结合 Spine → 普通头像，行为与数据完全不变
  const isMixed = shouldUseAvatarSpinePreview(selectedSkins, loadedRelatedTemplates)

  useEffect(() => {
    setCanvasDrawRef(drawRef)
    return () => setCanvasDrawRef(null)
  }, [setCanvasDrawRef])

  useEffect(() => {
    setCanvasCharDrawRef(charDrawRef)
    return () => setCanvasCharDrawRef(null)
  }, [setCanvasCharDrawRef])

  return (
    <div className="relative w-full h-full">
      {isMixed ? (
        <AvatarEditorPreview
          template={template}
          drawRef={drawRef}
          charDrawRef={charDrawRef}
        />
      ) : (
        <CanvasCore
          ow={template.ow}
          oh={template.oh}
          baseSize={getComponentCanvasSize(template.fullscreenType).w}
          baseHeight={getComponentCanvasSize(template.fullscreenType).h}
          drawRef={drawRef}
        />
      )}
      <Overlay
        drawRef={drawRef}
        charDrawRef={charDrawRef}
        spineSelectionActive={isMixed}
        fullscreenType={template.fullscreenType}
      />
    </div>
  )
}

export default CanvasPanel
